import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4158368348/src/lore-ui/components/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4158368348/src/lore-ui/components/Nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src4158368348/src/lore-ui/node_modules/.pnpm/next@15.5.12_@babel+core@7.29.0_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/next/dist/client/app-dir/link.js");
